import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export default class FilterListItem {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  profileName!: string;
}
